export default {
  name: "UploadIconSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};